import imagePolygon from "./imagePolygon";
import {UseFullSizeImages} from "../config";

const KIOSK_BVR_Root = document.kvConfig.imageServer + "/brv/";
const KIOSK_BV5_Root = document.kvConfig.imageServer + "/bv5/";

const KIOSK_KV_Root = document.kvConfig.imageServer + "/kv4/";
const KIOSK_KV5_Root = document.kvConfig.imageServer + "/kv5/";

const S3_BVR_Root = 'https://brv.s3-accelerate.amazonaws.com/';
const S3_BV5_Root = document.kvConfig.visualizerType === "bvLook"
  ? 'https://qc-bv5.s3-accelerate.amazonaws.com/'
  : 'https://qc-bv5.s3.amazonaws.com/';
const S3_BV6_Root = 'https://qc-fp5.s3.amazonaws.com/';

const S3_KV4_Root = 'https://kv4.s3-accelerate.amazonaws.com/';
const S3_KV5_Root = 'https://kv5.s3-accelerate.amazonaws.com/';
//const S3_BVR_Root = 'http://s3.gfd.us/';

const KIOSK_FEATURES_Root = document.kvConfig.imageServer + "/features-thumbnails/";
const S3_FEATURES_Root = 'https://features-thumbnails.s3-accelerate.amazonaws.com/';
const S3_FILTERS_Root = 'https://s3.amazonaws.com/';

export const THUMBNAIL_SIZES = {
  small:  `_100x100`,
  medium: `_175x175`,
  large:  `_400x400`,
}
export const LAYERS_SIZES = {
  normal: {
    width: 1620,
    height: 1080,
  },
  full_hd: {
    width: 1920,
    height: 1080,
  },
  full_hd_large: {
    width: 2880,
    height: 1620,
  },
  large: {
    width: 3000,
    height: 2000,
  },
}

/**
 * Case insensitive string inclusion
 * @param s3BindingName {string}
 * @param visualizer {string}
 * @param isCropped {boolean}
 * @returns {string}
 */
export function s3Path(s3BindingName, visualizer, isCropped = false) {
  let bvr_root = document.kvConfig.kioskMode ? KIOSK_BVR_Root : S3_BVR_Root;
  let bv5_root = document.kvConfig.kioskMode ? KIOSK_BV5_Root : S3_BV5_Root;
  let kv4_root = document.kvConfig.kioskMode ? KIOSK_KV_Root : S3_KV4_Root;
  let kv5_root = document.kvConfig.kioskMode ? KIOSK_KV5_Root : S3_KV5_Root;
  let bv6_root = document.kvConfig.kioskMode ? KIOSK_KV5_Root : S3_BV6_Root;
  // https://brv.s3.amazonaws.com/features/All%20-%20Background%20-%20Default.png
  let s3Root = "";
  switch (visualizer) {
    case "bv":
      s3Root = document.kvConfig.toolVersion === 5 || document.kvConfig.toolVersion === 6 ? bv5_root : bvr_root;
      break;
    case "kv":
      s3Root = document.kvConfig.toolVersion === 5 || document.kvConfig.toolVersion === 6 ? kv5_root : kv4_root;
      break;
    case "fireplace":
      s3Root = bv6_root;
      break;
    default:
      console.error("undefined visualizer", visualizer, s3BindingName);
      break;
  }
  let url = s3Root + s3BindingName;
  switch (document.kvConfig.layersSize) {
    case "full_hd":
      url += UseFullSizeImages || isCropped ? ".png" : "_1920x1080.png"
      break;
    default:
      url+= UseFullSizeImages || isCropped ? ".png" : "_1620x1080.png"
  }
  return encodeURI(url).replace(new RegExp('#', 'g'), '%23');
}

export function s3FilterImagePath(imageThumbnail) {
  return imageThumbnail ? `${S3_FILTERS_Root}filter-images/${imageThumbnail.replace(".png", "")}.png` : "";
}

// export function s3FeatureImagePath(imageThumbnail, smallThumbnail = false, largeThumbnail = false) {
//   const features_root = document.kvConfig.kioskMode ? KIOSK_FEATURES_Root : S3_FEATURES_Root;
//   const mobileThumbnailPath = `_100x100`;
//   const desktopThumbnailPath = `_175x175`;
//   return smallThumbnail
//     ? `${features_root}feature-${imageThumbnail + mobileThumbnailPath}.png`
//     : `${features_root}feature-${largeThumbnail ? imageThumbnail : imageThumbnail + desktopThumbnailPath}.png`;
// }
export function s3FeatureImagePath(imageThumbnail, size) {
  const features_root = document.kvConfig.kioskMode ? KIOSK_FEATURES_Root : S3_FEATURES_Root;
  return size
    ? `${features_root}feature-${imageThumbnail + size}.png`
    : `${features_root}feature-${imageThumbnail}.png` // full image path
}

export function className(instance) {
  if(instance && instance.constructor)
    return instance.constructor.name;
  console.log("Instance constructor not found", instance);
  return "";
}

export function ignoreDefault(e) {
  e.stopPropagation();
  e.preventDefault();
}

/**
 *
 * @param hayStack {string}
 * @param needle {string}
 * @return {boolean}
 */
export function iStartWith(hayStack, needle) {
  return hayStack ? hayStack.toLowerCase().startsWith(needle.toLowerCase()) : false
}

/**
 * Case insensitive string inclusion
 * @param hayStack {string}
 * @param needle {string}
 * @returns {boolean}
 */
export function iIncludes(hayStack, needle) {
  return hayStack ? hayStack.toLowerCase().includes(needle.toLowerCase()) : false
}

export function getNonce(length = 6) {
  let text = "";
  const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/**
 * Makes a case-insensitive string compare
 * @param s1 {string}
 * @param s2 {string}
 * @param needToUppercase {boolean}
 * @returns {boolean}
 */
export function iCmp(s1, s2, needToUppercase = false) {
  if (!s1 && !s2) {
    return true;
  }
  if (!s1 || !s2) {
    return false;
  }
  if (needToUppercase) {
    return s1.toUpperCase() === s2.toUpperCase()
  }
  return s1 === s2;
}

const RgFeatureName = /^([\w\s\d]+)\s*-\s*([\w\d\s]+)\s*([\[\(][(\d\w=;\s_\(\):,]+[\)\]]\s*)*$/i;

/**
 * Split a full feature name into: GroupName, FeatureName
 * @param name {string} Full Feature Name GroupName - Name
 * @param groupName {string}
 * @returns {*}
 */
export function splitFeatureName(name, groupName) {
  if (groupName && (groupName !== "Backsplash")) {
    return {featureName: name, groupName}
  }
  name = name.replace(/\"-/g, "in "); // for example Backsplash - 4"-6" Backsplash -> Backsplash - 4in 6in Backsplash
  name = name.replace(/\"/g, "in"); // for example Radius - 1" Radius -> Radius - 1in Radius
  const matches = RgFeatureName.exec(name);
  if (!matches) {
    return {}
  }
  return {
    groupName: matches[1].trim(),
    featureName: matches[2].trim(),
  }
}


export function styleBkgImage(image) {
  return {backgroundImage: `url('${image}')`};
}

export function getMetadataByDimensions(dimensions) {
  switch (dimensions) {
    case "30X8":
    case "Full":
      return "Full";
    case "15X4":
    case "Half":
      return "Half";
    case "Pony":
      return "Pony";
    default:
      return null;
  }
}

/**
 * Checked wheather an object is NULL, if not, calls the callback method with the object itself
 */
export function NN(obj, cb) {
  if (obj)
    cb(obj);
}

/**
 * returns clicked canvas coordinates as {x:value, y:value}
 */
export function getMousePos(evt, canvas) {
  const rect = canvas.getBoundingClientRect();
  return {
    x: evt.clientX - rect.left,
    y: evt.clientY - rect.top
  };
}

export function getFilterGroupValues(feature, filterGroup) {
  return feature.dbFeature.fabFilterValueIDs[filterGroup.id] || feature.dbFeature.filterValueIDs[filterGroup.id]
}
export const isFeatureHasFilterValue = (feature, filterValue) => {
  let testFabFilter = feature.dbFeature.fabFilterValueIDs[filterValue.filterGroup_id] &&
    feature.dbFeature.fabFilterValueIDs[filterValue.filterGroup_id].some(filterValueId => filterValueId === filterValue.id)
  let testFilter = feature.dbFeature.filterValueIDs[filterValue.filterGroup_id] &&
    feature.dbFeature.filterValueIDs[filterValue.filterGroup_id].some(filterValueId => filterValueId === filterValue.id)

  return testFabFilter || testFilter;
}
export function getFilterGroupValue(featureFilterValueId, filterGroup) {
  return filterGroup.values.find(val => val.id === featureFilterValueId);
}
export function getFilterGroupValueByName(name, filterGroup) {
  return filterGroup.values.find(val => val.value === name);
}

export const mergeFilterObjects = (filterValueIDs, fabFilterValueIDs) => {
  let unitedFilterValueIds = Object.assign({}, filterValueIDs || {}); // 1st create duplicate object
  Object.keys(fabFilterValueIDs || {}).forEach((filterKey) => {
    if (unitedFilterValueIds[filterKey]) { // group exist
      unitedFilterValueIds[filterKey] = [
        ...unitedFilterValueIds[filterKey],
        ...fabFilterValueIDs[filterKey]
      ];
    } else {
      unitedFilterValueIds[filterKey] = fabFilterValueIDs[filterKey] // set new key
    }
  });
  return unitedFilterValueIds
}

export function getAllFeatureFilters(feature) {
  return mergeFilterObjects(feature.dbFeature.filterValueIDs, feature.dbFeature.fabFilterValueIDs)
}

/**
 * Filters features according to received filters
 * @param feature {featureInterface}
 * @param filters {Object} array of objects with filters: [{ 18: 111 }, {5: 12}] etc.
 * @returns {Array}
 */
export function featureHasSelectedFilters(feature, filters) {
  const featureFilterValueIds = getAllFeatureFilters(feature);
  return filters.every(filterObject => {
    return featureFilterValueIds[filterObject.filterGroupId]
      && featureFilterValueIds[filterObject.filterGroupId].some(filterId => filterObject.filterId === filterId)
  })
}

/**
 * Filters features according to received filters
 * @param features {Array} Array of features
 * @param filters {[navigationFilterValueInterface]} array with filters: {filterId: 9, filterGroupId: 5}  // old logic object -> { 18: 111, 5: 12 } etc.
 * @returns {Array}
 */
export function filterFeaturesByValues(features, filters) {
  return features.filter(feature => {
    let unitedFilterValueIds = getAllFeatureFilters(feature);
    const newFiltersArray = [];
    filters.forEach((filterObject) => {
      const existingFilterGroup = newFiltersArray.find(filterGroupObject => {
        return filterGroupObject.filterGroupId === filterObject.filterGroupId
      });
      if (filterObject.filterId) {
        if (existingFilterGroup) {
          existingFilterGroup.filterValues.push(filterObject.filterId)
        } else {
          newFiltersArray.push({
            filterGroupId: filterObject.filterGroupId,
            filterValues: [filterObject.filterId]
          })
        }
      }
    });
    return newFiltersArray.every(filterObject => {
      const existingFeatureFilter = unitedFilterValueIds[filterObject.filterGroupId];
      return existingFeatureFilter && existingFeatureFilter.some(filterValue => {
        return filterObject.filterValues.some(filVal => filVal === filterValue)
      })
    })
  });
}

export function scrollToDivInArea(div, area) {
  const divOffset = div.offset();
  if (divOffset) {
    area.animate({
      scrollLeft: divOffset.left - area.offset().left + area.scrollLeft() - area.width()/2 + div.width()/2
    }, 600);
  }
}

export function getTranslateX(myElement) {
  const style = window.getComputedStyle(myElement);
  const matrix = new window.WebKitCSSMatrix(style.webkitTransform);
  return matrix.m41;
}

export function reorder(array, indexA, indexB) {
  const tmp = array[indexA];
  array[indexA] = array[indexB];
  array[indexB] = tmp;
  return array
}

/**
 * requestAnim shim layer by Paul Irish
 */
const updateRate = 1000 / 60; //ticks per second in miliseconds
export function requestAnimFrame() {
  return  window.requestAnimationFrame       ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame    ||
    window.oRequestAnimationFrame      ||
    window.msRequestAnimationFrame     ||
    function(callback){
      window.setTimeout(callback, updateRate);
    };
}

/**
 * checks for mobile state
 */
export function isTouchDevice() { // https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = function(query) {
    return window.matchMedia(query).matches;
  };

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

/**
 * creates a layer polygon https://stackoverflow.com/questions/23983461/creating-a-path-from-the-edge-of-an-image
 */

export function makeLayerPolygon(layer, image, width, height) {
  const fakeCanvas = document.createElement('canvas');
  fakeCanvas.setAttribute('height', `${height}px`);
  fakeCanvas.setAttribute('width', `${width}px`);
  const context2D = fakeCanvas.getContext("2d");

  // step 3 - make canvas layer 0.5 transparent
  context2D.globalAlpha = 0.5;

  // step 4 - put layer image on fake canvas
  context2D.clearRect(0, 0, fakeCanvas.width, fakeCanvas.height);
  context2D.drawImage(image, 0, 0);

  const imgData = context2D.getImageData(0,0, width, height);
  const layerPolygon = {
    layer,
    img: image,
    polygon: imagePolygon(imgData.data, width, height, layer.image)
  };
  // console.log('layerPolygon created!', layerPolygon);
  return layerPolygon
}
/**
 * checks if point is inside the polygon
 */
export function pnpoly(points, test) {
  let i, j, c = false;
  for (i = 0, j = points.length - 1; i < points.length; j = i++) {
    if (((points[i][1] > test.y) !== (points[j][1] > test.y)) &&
      (test.x < (points[j][0] - points[i][0]) * (test.y - points[i][1])
        / (points[j][1] - points[i][1]) + points[i][0])) {
      c = !c;
    }
  }
  return c;
}

export function base64ToBlob(base64, mime) {
  mime = mime || '';
  var sliceSize = 1024;
  var byteChars = window.atob(base64);
  var byteArrays = [];
  for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
    var slice = byteChars.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new window.Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {type: mime});
}
export function downloadCanvasImageById(canvasId) {
  const canvas = document.getElementById(canvasId);
  // console.log('canvasId', canvasId);
  // console.log('canvas', canvas);
  const imageUrl = canvas.toDataURL();
  var base64ImageContent = imageUrl.replace(/^data:image\/(png|jpg);base64,/, "");
  var blob = base64ToBlob(base64ImageContent, 'image/png');
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "bathroom-visualizer.png";
  a.click();
  window.URL.revokeObjectURL(url);
}

export const toBoolean = (value) => {
  if (typeof (value) === 'string') {
    value = value.toLowerCase();
  }
  switch (value) {
    case true:
    case "true":
    case 1:
    case "1":
    case "on":
    case "yes":
      return true;
    default:
      return false;
  }
};

export const capitalizeFirstLetters = (string) => {
  return string.replace(/(^\w|\s\w)/g, m => m.toUpperCase()) // ^\w - first character of the string, | - or,  \s\w - first character after whitespace, (^\w|\s\w) - Capture the pattern, g - Flag: Match all occurrences
}

export const isVisualizerRoute = () => {
  return window.location.hash.includes("visualizer") || (document.kvConfig.visualizerOnly && window.location.hash === "#/")
}

export const convertImgToBase64URL = (url, outputFormat = "image/jpeg") => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onerror = (e) => {
      console.log("couldn't load receipt logo image :(", e)
      resolve("");
    };
    img.onload = function () {
      let canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      let dataURL = "";
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0, img.width, img.height);
      if (url && url.includes(".png")) {
        outputFormat = "image/png";
      }
      dataURL = canvas.toDataURL(outputFormat);
      canvas = null;
      resolve(dataURL);
    };
    img.src = url;
  });
}
